module.exports = __webpack_public_path__ + "static/media/rolls-royce-logo-charcoal.9d7d93f3.svg";